// test2477
(2477 && 0);
